import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { cloneDeep, pick, debounce } from 'lodash';
import { Icon, Breadcrumb, Spin, Input } from 'mkui-fd';
import {
  buildSelectedData,
  buildBreadcrumbData,
  buildSelectedCodes,
  getSearchResult,
} from './util';
import noop from '../_util/noop';

const { Search } = Input;

class Panel extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    prefixCls: PropTypes.string,
    api: PropTypes.func,
    onSelect: PropTypes.func,
    showSearch: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
  };

  static defaultProps = {
    prefixCls: 'mk-enhanced-tree-select-panel',
    api: noop,
    onSelect: noop,
    showSearch: false,
    searchPlaceholder: '输入名称搜索',
  };

  static getDerivedStateFromProps(props, state) {
    if (props.data && props.data.code !== state.data.code) {
      return {
        data: props.data,
      };
    }
    return null;
  }

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      selectedCodes: [],
      spinning: false,
    };
    this.search = debounce(this.search, 500);
  }

  /** *******************handle************************** */
  selectCategoryHandle = (category) => {
    const { api } = this.props;
    const { data, selectedCodes } = this.state;
    const params = {
      referenceDataCode: data.code,
      categoryCode: category.code,
    };
    if (!category.inited) {
      this.setState({ spinning: true });
      api(params).then((response) => {
        category.items = response.items;
        if (response.categories) {
          category.categories = response.categories;
        }
        category.inited = true;
        this.setState({
          selectedCodes: [...selectedCodes, category.code],
          data: cloneDeep(data),
          spinning: false,
        });
      });
    } else {
      this.setState({
        selectedCodes: [...selectedCodes, category.code],
        data: cloneDeep(data),
      });
    }
  };

  selectOptionHandle = (option) => {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect([pick(option, ['name', 'code'])], option);
    }
  }

  clickBreadcrumbHandle = (item) => {
    const { selectedCodes } = this.state;
    const codes = buildSelectedCodes(selectedCodes, item.code);
    this.setState({
      selectedCodes: codes,
    });
  }

  searchHandle = (e) => {
    const keywords = e.target.value.trim();
    if (keywords) {
      this.search(keywords);
    } else {
      this.setState({
        searchResult: null,
      });
    }
  }

  /** *******************inner method************************** */
  search(keywords) {
    const { api } = this.props;
    this.setState({ spinning: true });
    api({ keywords }).then((response) => {
      const result = getSearchResult(response);
      this.setState({
        searchResult: result,
        spinning: false,
      });
    });
  }


  /** *******************render************************** */
  renderSearchResult() {
    const { prefixCls } = this.props;
    const { searchResult } = this.state;
    return searchResult && searchResult.length > 0 ? (
      <ul className={`${prefixCls}-search-result`}>
        {searchResult.map((item) => (
          <li key={item.code} onClick={() => { this.selectOptionHandle(item); }}>
            {item.fullName.join(' / ')}
          </li>
        ))}
      </ul>
    ) : (
      <div className={`${prefixCls}-search-empty`}>未搜索到相关记录。</div>
    );
  }

  renderContent() {
    const { prefixCls } = this.props;
    const { data, selectedCodes } = this.state;
    const selectedData = buildSelectedData(data, selectedCodes);
    const breadcrumbData = buildBreadcrumbData(data, selectedCodes);
    const categories = selectedData.categories || [];
    const items = selectedData.items || [];
    const isEmpty = !categories.length && !items.length;

    return (
      <Fragment>
        {/* <div className={`${prefixCls}-frequent`}>
          <div className={`${prefixCls}-frequent-title`}>最近选择</div>
          <ul>
            <li>云报销</li>
            <li>云报销</li>
            <li>云报销</li>
          </ul>
        </div> */}
        {breadcrumbData && (
          <div className={`${prefixCls}-breadcrumbs`}>
            <Breadcrumb>
              {breadcrumbData.map((item, index, arr) => {
                return index === arr.length - 1 ? (
                  <Breadcrumb.Item key={item.code}>
                    {item.name}
                  </Breadcrumb.Item>
                ) : (
                  <Breadcrumb.Item key={item.code}>
                    <a onClick={() => this.clickBreadcrumbHandle(item)}>{item.name}</a>
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
          </div>
        )}
        <div className={`${prefixCls}-list`}>
          {isEmpty ? (
            <div className={`${prefixCls}-list-empty`}>无选项内容</div>
          ) : (
            <ul>
              {categories.map((item) => (
                <li
                  key={item.code}
                  onClick={() => { this.selectCategoryHandle(item); }}
                >
                  <span>
                    <Icon className={`${prefixCls}-list-icon`} type="folder" theme="filled" />{item.name}
                  </span>
                  <Icon className={`${prefixCls}-arrow-icon`} type="right" />
                </li>
              ))}
              {items.map((item) => (
                <li
                  key={item.code}
                  onClick={() => { this.selectOptionHandle(item); }}
                >
                  <span>
                    <Icon className={`${prefixCls}-list-icon`} type="file" />{item.name}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Fragment>
    );
  }

  render() {
    const { prefixCls, showSearch, searchPlaceholder } = this.props;
    const { searchResult, spinning } = this.state;
    return (
      <div className={classNames(`${prefixCls}`)}>
        {showSearch && (
          <div className={`${prefixCls}-search`}>
            <Search
              className={`${prefixCls}-search-input`}
              placeholder={searchPlaceholder}
              onChange={this.searchHandle}
            />
          </div>
        )}
        <Spin spinning={spinning}>
          {showSearch && searchResult ? this.renderSearchResult() : this.renderContent()}
        </Spin>
      </div>
    );
  }
}

export default Panel;
